<template>
  <div ref="container" class="" style="overflow:hidden;">

    <div class="w100" layout="column top-center">


      <div class="layout-container wh100">

        <div class="content">
          <lightning class="lightning" :height="containerHeight" :flash-count="flashCount"/>
          <div v-for="element in layout.components" :class="{'black-background': hasBackground(element.type), 'components-container':true}" >
            <component
              v-bind="element"
              ref="blocks"
              v-bind:is="getComponentClass(element.type)"
              :city="$props.page"
              class="component"
            />
          </div>
          <spacing value="3rem"/>
          <smart-footer/>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
  import BackendProxy from '../BackendProxy';

  import SmartHeader from "./SmartHeader";
  import SmartFooter from "./SmartFooter";
  import Lightning from "./Lightning";

  import VideoPlayer from './blocks/VideoPlayer';
  import Headline from './blocks/Headline';
  import Spacing from './blocks/Spacing';
  import SmartMap from './blocks/SmartMap';
  import Textblock from './blocks/Textblock';
  import ScoreBars from './blocks/ScoreBars';
  import Empty from './blocks/Empty';
  import InstagramGrid from './blocks/InstragramGrid';
  import KeyVisual from './blocks/KeyVisual';
  import CityHeader from './blocks/CityHeader';
  import Cars from './blocks/Cars';
  import LocationMap from './blocks/LocationMap';

  export default {
    components: {
      Spacing,
      Lightning,
      SmartFooter,
      SmartHeader
    },
    name: "layout-renderer",
    props: ['page'],
    data() {
      return {
        layout: [],
        components: [],
        containerHeight: 0,
        flashCount:0
      }
    },
    methods: {
      getComponentClass(type) {
        const component = this.components[type];
        return component || Empty;
      },
      getComponentInstance(name) {
        const blocks = this.$refs.blocks;
        for (let i = 0; i < blocks.length; i++) {
          if (blocks[i].$options.name == name) {
            return blocks[i];
          }
        }
        return null;
      },
      hasBackground(type) {
        switch (type) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 9:
            return true;
          default:
            return false;
        }
      }
    },
    created() {
      this.layout = BackendProxy.instance.getLayout(this.page);

      const c = this.components = [];
      c[0] = KeyVisual;
      c[1] = Headline;
      c[2] = Textblock;
      //c[3] = Countdown;
      c[4] = ScoreBars;
      c[5] = VideoPlayer;
      c[6] = InstagramGrid;
      c[7] = SmartMap;
      c[8] = CityHeader;
      c[9] = Cars;
      c[10] = Spacing;
      c[11] = LocationMap;


      this.flashCount = this.page == 'home' ? 6 : 3;



    },
    mounted() {
      const update = () => {
        const ref = this.$refs.container;
        if (ref) this.containerHeight = ref.clientHeight + 'px';
      };

      this.inv = setInterval(update, 100);
      update();

    },
    destroyed() {
      clearInterval(this.inv);
    }
  }
</script>

<style lang="scss" scoped>



  .layout-container {
    width: 82%;
    max-width: 850px;
    min-width: 320px;
    @media screen and (max-width: 640px) {
      width: 80%;
    }
    @media screen and (max-width: 800px) {
      width: 80%;
    }

    overflow-y: visible;
    overflow-x: visible;

    /*background-color: red;*/


  }


  .components-container {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .component {
    /*margin-bottom: 0rem;*/
    /*background-color: #125C71;*/
  }

  .content {
    margin-top: 15vw;

    @media screen and (min-width: 1200px) {
      margin-top: 190px;
    }

    @media screen and (max-width: 800px) {
      margin-top: 110px;
    }

    height: 120%;

  }

  .lightning {



    @media screen and (max-width: 600px) {
      display: none;
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/LayoutRenderer.vue